/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ChairFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ChairFilled({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ChairFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1",
  stroke = "#9AA5B1",
  fill9 = "#fff",
  stroke8 = "#fff"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ChairFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 14"
 style={{'--as-1-ZBRTE6': alignSelf,'--mt-2-ZBRTE6': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZBRTE6': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZBRTE6': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZBRTE6': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZBRTE6': opacity,'--w-10-ZBRTE6': typeof width === 'number' ? `${width}px` : width,'--h-11-ZBRTE6': typeof height === 'number' ? `${height}px` : height,'--f-12-ZBRTE6': fill,'--a-7-ZBRTE6': isAnimated ? animation : "none",'--sd-8-ZBRTE6': isAnimated ? strokeDashoffset : 0,'--sd-9-ZBRTE6': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2ChairFilled.SvgPath"
  data-view-path={viewPath}
 d="M13.784 10.592h0l-3.34-1.715H6.245a.846.846 0 01-.414-.109L1.414 6.286h0a.845.845 0 01-.323-1.152l12.693 5.458zm0 0a.843.843 0 001.138-.366.845.845 0 00-.366-1.138h0L11.034 7.28h0a.846.846 0 00-.386-.093h-4.18L2.242 4.812h0m11.541 5.78L2.243 4.812m0 0a.845.845 0 00-1.152.322l1.152-.322z"
 strokeWidth=".5"
 style={{'--f-12-ZBRTE6': fill2,'--s-13-ZBRTE6': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="Tysiav2ChairFilled.SvgPath:1"
  data-view-path={viewPath}
 d="M14.557 9.09h0c.415.212.58.722.366 1.137l-.366-1.138zm0 0l-2.402-1.234-.364-.187m2.766 1.42l-2.766-1.42m0 0v.41m0-.41v.41m0 0v1.49m0-1.49v1.49m0 0l.136.07m-.136-.07l.136.07m0 0l1.858.954h0m-1.858-.954l1.858.954m0 0a.842.842 0 00.385.094m-.385-.094l.385.094m0 0a.845.845 0 00.753-.46l-.753.46zM6.677 11.928v.25h3.029v-.25h.25v-1.015a1.64 1.64 0 10-3.279 0v1.015z"
 strokeWidth=".5"
 style={{'--f-12-ZBRTE6': fill2,'--s-13-ZBRTE6': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
<path
  data-testid="Tysiav2ChairFilled.SvgPath:2"
  data-view-path={viewPath}
 d="M3.734 13.017v.25h8.914v-.25h.25v-.612a.729.729 0 00-.73-.73H4.464a.729.729 0 00-.729.73v.612zM.983 3.418a.845.845 0 101.691 0V1.83a.845.845 0 00-1.69 0v1.588z"
 strokeWidth=".5"
 style={{'--f-12-ZBRTE6': fill2,'--s-13-ZBRTE6': stroke}}
 className={`views-block ${styles.SvgPath2}`}
/>
<path
  data-testid="Tysiav2ChairFilled.SvgPath:3"
  data-view-path={viewPath}
 d="M7.958 9.314v.488c.51.114.89.568.89 1.11v1.266h1.108v-1.265 0a1.64 1.64 0 00-1.998-1.6zM10.838 13.017v.25h2.06v-.862a.729.729 0 00-.73-.73h-1.56v.5c.127 0 .23.103.23.23v.612z"
 strokeWidth=".5"
 style={{'--f-12-ZBRTE6': fill2,'--s-13-ZBRTE6': stroke}}
 className={`views-block ${styles.SvgPath3}`}
/>
<path
  data-testid="Tysiav2ChairFilled.SvgPath:4"
  data-view-path={viewPath}
 d="M8.957 9.97l.39.266V8.379H7.286V10.236l.39-.267a1.133 1.133 0 011.282 0zM10.898 5.723v-.25h-2.05v2.216h2.05V5.723zM.75 3.417a1.08 1.08 0 002.158 0V1.83a1.08 1.08 0 00-2.158 0v1.588zm.967-1.588c0-.062.05-.112.112-.112.061 0 .112.05.112.112v1.588a.112.112 0 01-.224 0V1.83z"
 strokeWidth=".5"
 style={{'--f-12-ZBRTE6': fill2,'--s-13-ZBRTE6': stroke}}
 className={`views-block ${styles.SvgPath4}`}
/>
<path
  data-testid="Tysiav2ChairFilled.SvgPath:5"
  data-view-path={viewPath}
 d="M13.678 10.803h0l-3.29-1.69H6.245c-.185 0-.367-.047-.528-.138h0L1.3 6.492h0a1.08 1.08 0 011.057-1.88s0 0 0 0L6.53 6.954h4.119c.17 0 .34.042.493.12l2.537 3.728zm0 0a1.082 1.082 0 001.452-.467c.132-.256.156-.549.068-.823a1.074 1.074 0 00-.534-.63s0 0 0 0L11.14 7.076l2.537 3.728zm.544-1.059h0l-3.523-1.809h0a.113.113 0 00-.051-.012H6.402a.483.483 0 01-.237-.062s0 0 0 0L1.883 5.454h0a.109.109 0 00-.054-.014.113.113 0 00-.098.057l12.49 4.247zm0 0a.11.11 0 01.055.066.11.11 0 01-.007.085.11.11 0 01-.15.048s0 0 0 0L10.724 8.2s0 0 0 0a.483.483 0 00-.221-.054H6.246a.113.113 0 01-.055-.014L1.774 5.649l12.448 4.095zM12.165 12.409v.124H4.468v-.124h7.697zM3.985 13.5h8.663l.234-.483h.25v0-.613a.963.963 0 00-.963-.963H4.463a.963.963 0 00-.962.963v.613c0 .267.216.483.483.483z"
 strokeWidth=".5"
 style={{'--f-12-ZBRTE6': fill2,'--s-13-ZBRTE6': stroke}}
 className={`views-block ${styles.SvgPath5}`}
/>
<path
  data-testid="Tysiav2ChairFilled.SvgPath:6"
  data-view-path={viewPath}
 d="M7.807 10.162h0a.9.9 0 011.019 0l.14-.207-.14.206a.483.483 0 00.498.028l-.117-.22.117.22a.483.483 0 00.257-.427V8.628a.484.484 0 00-.483-.483H7.535a.484.484 0 00-.484.483v1.134a.484.484 0 00.756.4zM9.098 7.921h1.55a.484.484 0 00.484-.483V5.722a.484.484 0 00-.484-.484h-1.55a.484.484 0 00-.484.484v1.716c0 .267.217.484.484.484zm1.066-1.716v.75h-.583v-.75h.584zM1.345 4.834a.484.484 0 10.968 0v-.823a.484.484 0 10-.968 0v.823z"
 strokeWidth=".5"
 style={{'--f-12-ZBRTE6': fill2,'--s-13-ZBRTE6': stroke}}
 className={`views-block ${styles.SvgPath6}`}
/>
<path
  data-testid="Tysiav2ChairFilled.SvgPath:7"
  data-view-path={viewPath}
 d="M8.316 11.096a.372.372 0 100-.744.372.372 0 000 .744z"
 style={{'--f-12-ZBRTE6': fill9,'--s-13-ZBRTE6': stroke8}}
 className={`views-block ${styles.SvgPath7}`}
/>
</svg>
{children}
</React.Fragment>)
}